'use strict';

import angular from 'angular';
import ImportController from './import.controller';

export default angular.module('onyxReadingRoomApp.appconfs.import', [])
  .controller('AppConfsImportController', ImportController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfs/import/index.js